import FormChangePassword from "../../../molecules/forms/FormChangePassword";

const ViewChangePassword = () => {
  return (
      <FormChangePassword />
  );
};

export default ViewChangePassword;
